module.exports = __webpack_public_path__ + "24e331dc605a74e48032d71c495a6684.mp4";